export default "__VITE_ASSET__BiBUzR4h__"